module.exports = __webpack_public_path__ + "static/media/fries.328b3f38.png";